/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { User } from '../../../../../model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AssigneeInfoContentComponent } from './assignee-content/assignee-content.component';

@Component({
  selector: 'app-assignee-profie-info',
  templateUrl: 'assignee-profile-info.component.html',
  styleUrls: ['assignee-profile-info.component.scss']
})
export class AssigneeProfileInfoComponent {
  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @Input() assignee: User;
  @Input() showHover = true;
  @Input() size: number = 30;
  @Input() isLeft: boolean = false;

  private tooltip: ComponentRef<any>;
  private visible: boolean;

  editModal: BsModalRef;
  rootUrl: string = "/api/file/users"

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver
  ) { }

  ngOnInit(): void {
   //Todo: testing purpose
    // if (Math.random() < 0.7) {
    //   this.assignee.AVATAR_URL = "https://i.stack.imgur.com/YaL3s.jpg";
    // }
  }


  @HostListener('focusin')
  @HostListener('mouseenter')
  showInfo(): void {
    if (this.showHover) {
      if (this.visible)
        return;

      this.visible = true;
      const factory = this.resolver.resolveComponentFactory(AssigneeInfoContentComponent);
      this.tooltip = this.target.createComponent(factory);
      this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
      this.tooltip.instance.data = this.assignee;
      this.tooltip.instance.isLeft = this.isLeft;
    }
  }

  @HostListener('focusout')
  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible)
      return;

    this.visible = false;
    if (this.tooltip)
      this.tooltip.destroy();
  }
}


